/**
 * Обработчик нажатия на кнопку «Высокая важность» в карточке задачи.
 *
 * @global
 * @async
 * @function toggleHighImportance
 * @param {string} SaveBtnName Название кнопки «Сохранить». Кнопка станет доступна после нажатия на кнопку «Высокая важность»
 */
async function toggleHighImportance(SaveBtnName) {
  await _sendSetImportanceRequest(TASK_IMPORTANCE.HIGH, SaveBtnName);
  _changeImportanceButtonStates('TaskHighImp', 'TaskLowImp');
}

/**
 * Обработчик нажатия на кнопку «Низкая важность» в карточке задачи.
 *
 * @global
 * @async
 * @function toggleLowImportance
 * @param {string} SaveBtnName Название кнопки «Сохранить». Кнопка станет доступна после нажатия на кнопку «Низкая важность»
 */
async function toggleLowImportance(SaveBtnName) {
  await _sendSetImportanceRequest(TASK_IMPORTANCE.LOW, SaveBtnName);
  _changeImportanceButtonStates('TaskLowImp', 'TaskHighImp');
}

/**
 * Переключает режим контроля задачи.
 *
 * @global
 * @function toggleCheckedTask
 * @param {string} SaveBtnName Название кнопки «Сохранить». Кнопка станет доступна после нажатия на кнопку «Контроль задачи»
 */
async function toggleCheckedTask(SaveBtnName) {
  let checkedButton = WA.CR.toolBar.buttons['CheckedTask'];
  let newCheckedTaskMode = !checkedButton.isSelected();

  await _sendSetCheckedTaskRequest(newCheckedTaskMode, SaveBtnName);
  _toggleButtonState('CheckedTask');
}

/**
 * Переключает режим уведомления об этапах.
 *
 * @global
 * @function toggleCheckedRoute
 * @param {string} SaveBtnName Название кнопки «Сохранить». Кнопка станет доступна после нажатия на кнопку «Уведомление об этапах»
 */
async function toggleCheckedRoute(SaveBtnName) {
  let checkedButton = WA.CR.toolBar.buttons['CheckedRoute'];
  let newCheckedRouteMode = !checkedButton.isSelected();

  await _sendSetCheckedRouteRequest(newCheckedRouteMode, SaveBtnName);
  _toggleButtonState('CheckedRoute');
}

/**
 * Отправляет запрос на установку важности задачи.
 *
 * @global
 * @private
 * @ignore
 * @function _sendSetImportanceRequest
 * @param {TASK_IMPORTANCE} level Важность задачи.
 * @param {string} SaveBtnName Название кнопки "Сохранить", чтобы разблокировать её.
 */
function _sendSetImportanceRequest(level, SaveBtnName) {
  return new Promise((resolve, reject) => {
    WA.SRV.call('/Task.asmx/SetImportance', {
      TaskID: WA.CR.ID,
      Importance: level,
    }).done((level) => {
      WA.CR.toolBar.buttons[SaveBtnName].enable();
      WA.Task.Importance = WA.CR.Importance = level;
      resolve();
    }).fail((message) => {
      reject(message);
    });
  });
}

/**
 * Отправляет запрос на установку контроля задачи.
 *
 * @global
 * @private
 * @ignore
 * @function _sendSetCheckedTaskRequest
 * @param {boolean} checkedTask Контроль задачи.
 * @param {string} SaveBtnName Название кнопки "Сохранить", чтобы разблокировать её.
 */
function _sendSetCheckedTaskRequest(checkedTask, SaveBtnName) {
  return new Promise((resolve, reject) => {
    WA.SRV.call('/Task.asmx/SetCheckedTask', {
      TaskID: WA.CR.ID,
      CheckedTask: checkedTask,
    }).done((checkedTask) => {
      WA.CR.toolBar.buttons[SaveBtnName].enable();
      WA.Task.CheckedTask = WA.CR.CheckedTask = checkedTask;
      resolve();
    }).fail((message) => {
      reject(message);
    });
  });
}

/**
 * Отправляет запрос на установку уведомления об этапах.
 *
 * @global
 * @private
 * @ignore
 * @function _sendSetCheckedRouteRequest
 * @param {boolean} checkedRoute Уведомление об этапах.
 * @param {string} SaveBtnName Название кнопки "Сохранить", чтобы разблокировать её.
 */
function _sendSetCheckedRouteRequest(checkedRoute, SaveBtnName) {
  return new Promise((resolve, reject) => {
    WA.SRV.call('/Task.asmx/SetCheckedRoute', {
      TaskID: WA.CR.ID,
      CheckedRoute: checkedRoute,
    }).done((checkedRoute) => {
      WA.CR.toolBar.buttons[SaveBtnName].enable();
      WA.Task.CheckedRoute = WA.CR.CheckedRoute = checkedRoute;
      resolve();
    }).fail((message) => {
      reject(message);
    });
  });
}

/**
 * Устанавливает выделенность кнопок важности задачи.
 *
 * @global
 * @private
 * @ignore
 * @function _changeImportanceButtonStates
 * @param {string} settableButtonName Имя кнопки, которая была нажата.
 * @param {string} resetButtonName Имя кнопки, выделение которой будет снято.
 */
function _changeImportanceButtonStates(settableButtonName, resetButtonName) {
  let settableImportanceButton = WA.CR.toolBar.buttons[settableButtonName];
  if (settableImportanceButton.isSelected()) {
    settableImportanceButton.unSelect();
  } else {
    settableImportanceButton.select();
  }

  let resetImportanceButton = WA.CR.toolBar.buttons[resetButtonName];
  if (resetImportanceButton.isSelected()) {
    resetImportanceButton.unSelect();
  }
}

/**
 * Устанавливает выделенность кнопки.
 *
 * @global
 * @private
 * @ignore
 * @function _changeButtonState
 * @param {string} buttonName Имя кнопки, которая была нажата.
 * @param {boolean} isSelected Устанавливаемое состояние выделения.
 */
function _toggleButtonState(buttonName) {
  let button = WA.CR.toolBar.buttons[buttonName];
  if (button.isSelected()) {
    button.unSelect();
  } else {
    button.select();
  }
}

/**
 * Устанавливает важность задачи.
 *
 * @global
 * @private
 * @ignore
 * @function DoImportance
 * @param {object} el DOM-элемент кнопки панели действий.
 * @param {string} val Устанавливаемая важность.
 * @param {string} css Добавляемый класс.
 * @deprecated since 5.6.0.1300
 */
function DoImportance(el, val, css) {
  UnbindBeforeUnload();
  MakeRequestImportance(GetParamInURL('id'), val, function (res) {
    if (res.d) {
      if ($(el).hasClass(css)) {
        $(el).removeClass(css);
      } else {
        $(el).addClass(css);
      }
      if (val === 'High') {
        $(el).next().removeClass(css);
      } else if (val === 'Low') {
        $(el).prev().removeClass(css);
      }
    }
  });
}

/**
 * Сформировать и отправить запрос на установку важности.
 *
 * @global
 * @private
 * @ignore
 * @function MakeRequestImportance
 * @param {number} TaskID ИД задачи.
 * @param {string} Value Устанавливаемая важность.
 * @param {function} CallbackFunc Callback-функция.
 * @deprecated since 5.6.0.1300
 */
function MakeRequestImportance(TaskID, Value, CallbackFunc) {
  var WSSParam = GetWSSParam(location.href, true);
  $.ajax({
    type: 'POST',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    url: '/Task.asmx/DoImportance' + WSSParam,
    data: '{"TaskID":"' + TaskID + '", "Value":"' + Value + '"}',
    success: function (res) {
      if (!CheckForLoginPage(res.d)) {
        CallbackFunc(res);
      }
    }
  });
}

/**
 * Устанавливает высокую важность для задачи.
 *
 * @global
 * @function DoHighImportance
 * @param {object} el DOM-элемент кнопки "Высокая важность".
 * @deprecated since 5.6.0.1300
 */
function DoHighImportance(el) {
  DoImportance(el, 'High', 'selected');
}

/**
 * Устанавливает низкую важность для задачи.
 *
 * @global
 * @function DoLowImportance
 * @param {object} el DOM-элемент кнопки "Низкая важность".
 * @deprecated since 5.6.0.1300
 */
function DoLowImportance(el) {
  DoImportance(el, 'Low', 'selected');
}